/**
 * Count-up animation for stat numbers.
 * Elements with `.count-up` and `data-count` attribute will animate on scroll.
 * Handles numbers with prefixes/suffixes (e.g. "5u", "#1", "365").
 */

function animateCountUp(el) {
  const raw = el.dataset.count || el.textContent;

  // Extract number and prefix/suffix
  const match = raw.match(/^([^\d]*)(\d+)(.*)$/);
  if (!match) return;

  const prefix = match[1]; // e.g. "#"
  const target = parseInt(match[2], 10); // e.g. 365
  const suffix = match[3]; // e.g. "u"

  const duration = 2000;
  const startTime = performance.now();

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function update(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeOutCubic(progress);
    const current = Math.round(easedProgress * target);

    el.textContent = prefix + current + suffix;

    if (progress < 1) {
      requestAnimationFrame(update);
    }
  }

  el.textContent = prefix + "0" + suffix;
  requestAnimationFrame(update);
}

// Trigger on scroll into view
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateCountUp(entry.target);
        observer.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.5 }
);

document.querySelectorAll(".count-up").forEach((el) => {
  observer.observe(el);
});
